import React, { useState } from "react";
import {
  Badge,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";
import { MoreVert, Search, Check } from "@mui/icons-material";

const AllTransactionsSearch = ({ searchText, onSearchChange, searchFilter, onFilterChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFilterSelect = (filter) => {
    onFilterChange(filter);
    handleMenuClose();
  };

  const FILTER_OPTIONS = [
    { key: "transactionId", label: "Transaction ID" },
    { key: "userId", label: "User ID" },
  ];

  const getPlaceholder = () => {
    const selected = FILTER_OPTIONS.find((f) => f.key === searchFilter);
    return `Search by ${selected?.label || "Transaction ID"}`;
  };

  return (
    <Box>
      <TextField
        size="small"
        fullWidth
        variant="outlined"
        placeholder={getPlaceholder()}
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="Search filters">
                <IconButton
                  onClick={handleMenuOpen}
                  size="small"
                  sx={{ ml: 0.5 }}
                  aria-controls={open ? "filter-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <Badge
                    variant="dot"
                    color="primary"
                    invisible={searchFilter === "transactionId"}
                    overlap="circular"
                  >
                    <MoreVert />
                  </Badge>
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorEl}
                id="filter-menu"
                open={open}
                onClose={handleMenuClose}
                onClick={handleMenuClose}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      minWidth: 180,
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Typography variant="caption" pl={2} color="text.secondary">
                  Search by
                </Typography>
                {FILTER_OPTIONS.map((filter) => (
                  <MenuItem
                    dense
                    key={filter.key}
                    selected={filter.key === searchFilter}
                    onClick={() => handleFilterSelect(filter.key)}
                  >
                    {filter.label}
                    {filter.key === searchFilter && (
                      <Check fontSize="small" sx={{ ml: 1 }} />
                    )}
                  </MenuItem>
                ))}
              </Menu>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default AllTransactionsSearch;
